(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["MTH-horizontal-scroll"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

  const baseRow = document.querySelector('.MTH-base-row');

  const indicator = document.querySelector('.MTH-indicator-base .MTH-indicator');

  const indicatorBase = document.querySelector('.MTH-indicator-base');

  const leftArrow = document.querySelector('.MTH-left-arrow');

  const rightArrow = document.querySelector('.MTH-right-arrow');

  const scrollWidth = baseRow.scrollWidth;

  const clientWidth = baseRow.clientWidth;


  rightArrow.classList.add('MTH-floating');


  leftArrow.addEventListener('click', () => {

    const scrollPercentage =
      Math.ceil(
        (baseRow.scrollLeft /
          (baseRow.scrollWidth - baseRow.clientWidth)) * 100
      );

    let targetPercentage;

    if (scrollPercentage > 38) {
      targetPercentage = 38;
    } else {
      targetPercentage = 0;
    }

    const targetPosition =
      (targetPercentage / 100) *
      (baseRow.scrollWidth - baseRow.clientWidth);

    console.log(
      targetPercentage,
      scrollPercentage,
      targetPosition
    );

    baseRow.scrollTo({
      left: targetPosition,
      behavior: 'smooth'
    });

  });


  rightArrow.addEventListener('click', () => {

    rightArrow.classList.remove('MTH-floating');

    const scrollPercentage =
      Math.ceil(
        (baseRow.scrollLeft /
          (baseRow.scrollWidth - baseRow.clientWidth)) * 100
      );

    let targetPercentage;

    if (scrollPercentage < 38) {
      targetPercentage = 38;
    } else {
      targetPercentage = 100;
    }

    const targetPosition =
      (targetPercentage / 100) *
      (baseRow.scrollWidth - baseRow.clientWidth);

    baseRow.scrollTo({
      left: targetPosition,
      behavior: 'smooth'
    });

  });


  const maxMove = 59;

  let isDragging = false;

  let startX;

  let startLeft;


  leftArrow.style.display = 'none';


  baseRow.addEventListener('scroll', () => {

    const scrollPercentage =
      (baseRow.scrollLeft /
        (baseRow.scrollWidth - baseRow.clientWidth)) * 100;

    const indicatorPosition =
      (scrollPercentage / 100) * maxMove;

    indicator.style.left =
      `${indicatorPosition}px`;


    if (scrollPercentage === 0) {

      leftArrow.style.display = 'none';

    }

    else if (scrollPercentage === 100) {

      rightArrow.style.display = 'none';

    }

    else {

      leftArrow.style.display = 'block';

      rightArrow.style.display = 'block';

    }

  });


  const startDragging = (e) => {

    isDragging = true;

    startX =
      e.type.includes('mouse')
        ? e.clientX
        : e.touches[0].clientX;

    startLeft =
      parseInt(indicator.style.left || 0);

    if (e.type === 'mousedown') {
      document.body.style.cursor = 'grabbing';
    }

  };


  const handleDrag = (e) => {

    if (!isDragging) return;

    e.preventDefault();

    const currentX =
      e.type.includes('mouse')
        ? e.clientX
        : e.touches[0].clientX;

    const deltaX =
      currentX - startX;

    let newLeft =
      startLeft + deltaX;

    newLeft =
      Math.max(
        0,
        Math.min(newLeft, maxMove)
      );

    indicator.style.left =
      `${newLeft}px`;


    const scrollPercentage =
      newLeft / maxMove;

    const scrollPosition =
      scrollPercentage *
      (baseRow.scrollWidth - baseRow.clientWidth);

    baseRow.scrollLeft =
      scrollPosition;

  };


  const stopDragging = () => {

    isDragging = false;

    document.body.style.cursor = 'default';

  };


  indicatorBase.addEventListener(
    'touchstart',
    startDragging
  );

  document.addEventListener(
    'touchmove',
    handleDrag,
    { passive: false }
  );

  document.addEventListener(
    'touchend',
    stopDragging
  );


  indicatorBase.addEventListener(
    'mousedown',
    startDragging
  );

  document.addEventListener(
    'mousemove',
    handleDrag
  );

  document.addEventListener(
    'mouseup',
    stopDragging
  );

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["athlos-product-horizontal-scroll-slider-2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
            const baseRow = document.querySelector('.base-row');
            const indicator = document.querySelector('.indicator');
            const indicatorBase = document.querySelector('.indicator-base');


  // arrow click functionality
            const leftArrow = document.querySelector('.left-arrow');
            const rightArrow = document.querySelector('.right-arrow');
            const scrollWidth = baseRow.scrollWidth;
            const clientWidth = baseRow.clientWidth;

            // Add floating class to right arrow on page load
            rightArrow.classList.add('floating');


            // Scroll to the left when clicking the left arrow
            leftArrow.addEventListener('click', () => {
                // Calculate current scroll percentage
                const scrollPercentage = Math.ceil((baseRow.scrollLeft / (baseRow.scrollWidth - baseRow.clientWidth)) * 100);
                
                // Determine target percentage (0% or 50%)
                let targetPercentage;
                if (scrollPercentage > 33) {
                    targetPercentage = 33;
                } else {
                    targetPercentage = 0;
                }
                
                // Calculate target scroll position
                const targetPosition = (targetPercentage / 100) * (baseRow.scrollWidth - baseRow.clientWidth);
              console.log(targetPercentage, scrollPercentage, targetPosition)
                
                // Scroll to target position
                baseRow.scrollTo({
                    left: targetPosition,
                    behavior: 'smooth'
                });
            });
            
            // Scroll to the right when clicking the right arrow
            rightArrow.addEventListener('click', () => {
                // Stop the animation when clicked
                rightArrow.classList.remove('floating');
              
                // Calculate current scroll percentage
                const scrollPercentage = Math.ceil((baseRow.scrollLeft / (baseRow.scrollWidth - baseRow.clientWidth)) * 100);
                
                // Determine target percentage (50% or 100%)
                let targetPercentage;
                if (scrollPercentage < 33) {
                    targetPercentage = 33;
                } else {
                    targetPercentage = 100;
                }
                
                // Calculate target scroll position
                const targetPosition = (targetPercentage / 100) * (baseRow.scrollWidth - baseRow.clientWidth);
                // Scroll to target position
                baseRow.scrollTo({
                    left: targetPosition,
                    behavior: 'smooth'
                });
            });


            const maxMove = 59;
            let isDragging = false;
            let startX;
            let startLeft;

            //set initial display none
            leftArrow.style.display = 'none';


            // Update indicator position when scrolling
            baseRow.addEventListener('scroll', () => {
                const scrollPercentage = (baseRow.scrollLeft / (baseRow.scrollWidth - baseRow.clientWidth)) * 100;
                const indicatorPosition = (scrollPercentage / 100) * maxMove;
                indicator.style.left = `${indicatorPosition}px`;

              if(scrollPercentage === 0) {
                leftArrow.style.display = 'none';
              }
              else if (scrollPercentage === 100) {
                rightArrow.style.display = 'none';
              }
              else {
                leftArrow.style.display = 'block';
                rightArrow.style.display = 'block';
              }
            });

            // Handle touch events for mobile and mouse events for desktop
            const startDragging = (e) => {
                isDragging = true;
                startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
                startLeft = parseInt(indicator.style.left || 0);
                if (e.type === 'mousedown') document.body.style.cursor = 'grabbing';
            };

            const handleDrag = (e) => {
                if (!isDragging) return;
                e.preventDefault(); // Prevent scrolling while dragging

                const currentX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
                const deltaX = currentX - startX;
                let newLeft = startLeft + deltaX;

                // Constrain indicator movement
                newLeft = Math.max(0, Math.min(newLeft, maxMove));
                indicator.style.left = `${newLeft}px`;

                // Update scroll position
                const scrollPercentage = newLeft / maxMove;
                const scrollPosition = scrollPercentage * (baseRow.scrollWidth - baseRow.clientWidth);
                baseRow.scrollLeft = scrollPosition;
            };

            const stopDragging = () => {
                isDragging = false;
                document.body.style.cursor = 'default';
            };

            // Touch events
            indicatorBase.addEventListener('touchstart', startDragging);
            document.addEventListener('touchmove', handleDrag, { passive: false });
            document.addEventListener('touchend', stopDragging);

            // Mouse events
            indicatorBase.addEventListener('mousedown', startDragging);
            document.addEventListener('mousemove', handleDrag);
            document.addEventListener('mouseup', stopDragging);
            document.addEventListener('mouseup', () => {
                isDragging = false;
                document.body.style.cursor = 'default';
            });
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["athlos-product-horizontal-scroll-slider-3"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const baseRow = document.querySelector('.base-row');
  const indicator = document.querySelector('.indicator-base .indicator');
  const indicatorBase = document.querySelector('.indicator-base');
  // arrow click functionality
  const leftArrow = document.querySelector('.left-arrow');
  const rightArrow = document.querySelector('.right-arrow');
  const scrollWidth = baseRow.scrollWidth;
  const clientWidth = baseRow.clientWidth;

  // Add floating class to right arrow on page load
  rightArrow.classList.add('floating');


  // Scroll to the left when clicking the left arrow
  leftArrow.addEventListener('click', () => {
      // Calculate current scroll percentage
      const scrollPercentage = Math.ceil((baseRow.scrollLeft / (baseRow.scrollWidth - baseRow.clientWidth)) * 100);
      
      // Determine target percentage (0% or 50%)
      let targetPercentage;
      if (scrollPercentage > 38) {
          targetPercentage = 38;
      } else {
          targetPercentage = 0;
      }
      
      // Calculate target scroll position
      const targetPosition = (targetPercentage / 100) * (baseRow.scrollWidth - baseRow.clientWidth);
    console.log(targetPercentage, scrollPercentage, targetPosition)
      
      // Scroll to target position
      baseRow.scrollTo({
          left: targetPosition,
          behavior: 'smooth'
      });
  });
  
  // Scroll to the right when clicking the right arrow
  rightArrow.addEventListener('click', () => {
      // Stop the animation when clicked
      rightArrow.classList.remove('floating');
    
      // Calculate current scroll percentage
      const scrollPercentage = Math.ceil((baseRow.scrollLeft / (baseRow.scrollWidth - baseRow.clientWidth)) * 100);
      
      // Determine target percentage (50% or 100%)
      let targetPercentage;
      if (scrollPercentage < 38) {
          targetPercentage = 38;
      } else {
          targetPercentage = 100;
      }
      
      // Calculate target scroll position
      const targetPosition = (targetPercentage / 100) * (baseRow.scrollWidth - baseRow.clientWidth);
      // Scroll to target position
      baseRow.scrollTo({
          left: targetPosition,
          behavior: 'smooth'
      });
  });


  const maxMove = 59;
  let isDragging = false;
  let startX;
  let startLeft;

  //set initial display none
  leftArrow.style.display = 'none';


  // Update indicator position when scrolling
  baseRow.addEventListener('scroll', () => {
      const scrollPercentage = (baseRow.scrollLeft / (baseRow.scrollWidth - baseRow.clientWidth)) * 100;
      const indicatorPosition = (scrollPercentage / 100) * maxMove;
      indicator.style.left = `${indicatorPosition}px`;

    if(scrollPercentage === 0) {
      leftArrow.style.display = 'none';
    }
    else if (scrollPercentage === 100) {
      rightArrow.style.display = 'none';
    }
    else {
      leftArrow.style.display = 'block';
      rightArrow.style.display = 'block';
    }
  });

  // Handle touch events for mobile and mouse events for desktop
  const startDragging = (e) => {
    isDragging = true;
    startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
    startLeft = parseInt(indicator.style.left || 0);
    if (e.type === 'mousedown') document.body.style.cursor = 'grabbing';
  };

  const handleDrag = (e) => {
    if (!isDragging) return;
    e.preventDefault(); // Prevent scrolling while dragging

    const currentX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
    const deltaX = currentX - startX;
    let newLeft = startLeft + deltaX;

    // Constrain indicator movement
    newLeft = Math.max(0, Math.min(newLeft, maxMove));
    indicator.style.left = `${newLeft}px`;

    // Update scroll position
    const scrollPercentage = newLeft / maxMove;
    const scrollPosition = scrollPercentage * (baseRow.scrollWidth - baseRow.clientWidth);
    baseRow.scrollLeft = scrollPosition;
  };

  const stopDragging = () => {
    isDragging = false;
    document.body.style.cursor = 'default';
  };

  // Touch events
  indicatorBase.addEventListener('touchstart', startDragging);
  document.addEventListener('touchmove', handleDrag, { passive: false });
  document.addEventListener('touchend', stopDragging);

  // Mouse events
  indicatorBase.addEventListener('mousedown', startDragging);
  document.addEventListener('mousemove', handleDrag);
  document.addEventListener('mouseup', stopDragging);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["athlos-product-horizontal-scroll-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const baseRow = document.querySelector('.base-row');
  const trigger1 = document.querySelector('.trigger-1');
  const trigger2 = document.querySelector('.trigger-2');

              const leftArrow = document.querySelector('.left-arrow');
            const rightArrow = document.querySelector('.right-arrow');
            const scrollWidth = baseRow.scrollWidth;
            const clientWidth = baseRow.clientWidth;

            // hide left arrow when position is 0 and right arrow when position is max
            const updateArrows = () => {
                if (baseRow.scrollLeft === 0) {
                    leftArrow.style.display = 'none';
                } else {
                    leftArrow.style.display = 'block';
                }

                if (baseRow.scrollLeft + clientWidth >= scrollWidth) {
                    rightArrow.style.display = 'none';
                } else {
                    rightArrow.style.display = 'block';
                }
            }

            // update arrows on load
            updateArrows();

            // update arrows on scroll
            baseRow.addEventListener('scroll', () => {
                updateArrows();
            });


            // Scroll to the left when clicking the left arrow
            leftArrow.addEventListener('click', () => {
                baseRow.scrollBy({
                    left: -clientWidth,
                    behavior: 'smooth'
                })
            })
            // Scroll to the right when clicking the right arrow
            rightArrow.addEventListener('click', () => {
                baseRow.scrollBy({
                    left: clientWidth,
                    behavior:'smooth'
                })
            });

  
  const scrollAmount1 = '0%';
  const scrollAmount2 = '33%';
  const scrollAmount3 = '100%';
  let lastScrollY = window.scrollY;
  let initialLoadComplete = false;

  // Set initial position
  baseRow.style.transform = `translateX(0)`;

  const observer = new IntersectionObserver((entries) => {
    if (!initialLoadComplete) {
      initialLoadComplete = true;
      return;
    }

    entries.forEach((entry) => {
      const scrollingDown = window.scrollY > lastScrollY;
      lastScrollY = window.scrollY;

      if (entry.isIntersecting) {
        if (scrollingDown) {
          if (entry.target === trigger1) {
            baseRow.style.transform = `translateX(-${scrollAmount3})`;
          } else if (entry.target === trigger2) {
            baseRow.style.transform = `translateX(-${scrollAmount3})`;
          }
        }
      } else {
        if (!scrollingDown) {
          if (entry.target === trigger1 && window.scrollY < trigger1.offsetTop) {
            baseRow.style.transform = `translateX(-${scrollAmount1})`;
          }
          if (entry.target === trigger2 && window.scrollY < trigger2.offsetTop) {
            baseRow.style.transform = `translateX(-${scrollAmount3})`;
          }
        }
      }
    });
  }, {
    threshold: 0.1
  });

  observer.observe(trigger1);
  observer.observe(trigger2);

  if (window.innerWidth <= 800) {
    const baseRow = document.querySelector('.base-row');
    const indicator = document.querySelector('.indicator');
    
    baseRow.addEventListener('scroll', () => {
      const scrollPercentage = (baseRow.scrollLeft / (baseRow.scrollWidth - baseRow.clientWidth)) * 100;
      const maxMove = 59;
      const indicatorPosition = (scrollPercentage / 100) * maxMove;
      indicator.style.left = `${indicatorPosition}px`;
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["athlos-product-horizontal-slider-3"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const baseRow = document.querySelector('.base-row');
  const indicator = document.querySelector('.indicator-base .indicator');
  const indicatorBase = document.querySelector('.indicator-base');

  // arrow click functionality
  const leftArrow = document.querySelector('.left-arrow');
  const rightArrow = document.querySelector('.right-arrow');
  const scrollWidth = baseRow.scrollWidth;
  const clientWidth = baseRow.clientWidth;

  // Add floating class to right arrow on page load
  rightArrow.classList.add('floating');


  // Scroll to the left when clicking the left arrow
  leftArrow.addEventListener('click', () => {
      // Calculate current scroll percentage
      const scrollPercentage = Math.ceil((baseRow.scrollLeft / (baseRow.scrollWidth - baseRow.clientWidth)) * 100);
      
      // Determine target percentage (0% or 50%)
      let targetPercentage;
      if (scrollPercentage > 33) {
          targetPercentage = 33;
      } else {
          targetPercentage = 0;
      }
      
      // Calculate target scroll position
      const targetPosition = (targetPercentage / 100) * (baseRow.scrollWidth - baseRow.clientWidth);
    console.log(targetPercentage, scrollPercentage, targetPosition)
      
      // Scroll to target position
      baseRow.scrollTo({
          left: targetPosition,
          behavior: 'smooth'
      });
  });
  
  // Scroll to the right when clicking the right arrow
  rightArrow.addEventListener('click', () => {
      // Stop the animation when clicked
      rightArrow.classList.remove('floating');
    
      // Calculate current scroll percentage
      const scrollPercentage = Math.ceil((baseRow.scrollLeft / (baseRow.scrollWidth - baseRow.clientWidth)) * 100);
      
      // Determine target percentage (50% or 100%)
      let targetPercentage;
      if (scrollPercentage < 33) {
          targetPercentage = 33;
      } else {
          targetPercentage = 100;
      }
      
      // Calculate target scroll position
      const targetPosition = (targetPercentage / 100) * (baseRow.scrollWidth - baseRow.clientWidth);
      // Scroll to target position
      baseRow.scrollTo({
          left: targetPosition,
          behavior: 'smooth'
      });
  });

  
  const maxMove = 59;
  let isDragging = false;
  let startX;
  let startLeft;

  //set initial display none
    leftArrow.style.display = 'none';


    // Update indicator position when scrolling
    baseRow.addEventListener('scroll', () => {
        const scrollPercentage = (baseRow.scrollLeft / (baseRow.scrollWidth - baseRow.clientWidth)) * 100;
        const indicatorPosition = (scrollPercentage / 100) * maxMove;
        indicator.style.left = `${indicatorPosition}px`;

      if(scrollPercentage === 0) {
        leftArrow.style.display = 'none';
      }
      else if (scrollPercentage === 100) {
        rightArrow.style.display = 'none';
      }
      else {
        leftArrow.style.display = 'block';
        rightArrow.style.display = 'block';
      }
    });

  // Handle touch events for mobile and mouse events for desktop
  const startDragging = (e) => {
    isDragging = true;
    startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
    startLeft = parseInt(indicator.style.left || 0);
    if (e.type === 'mousedown') document.body.style.cursor = 'grabbing';
  };

  const handleDrag = (e) => {
    if (!isDragging) return;
    e.preventDefault(); // Prevent scrolling while dragging

    const currentX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
    const deltaX = currentX - startX;
    let newLeft = startLeft + deltaX;

    // Constrain indicator movement
    newLeft = Math.max(0, Math.min(newLeft, maxMove));
    indicator.style.left = `${newLeft}px`;

    // Update scroll position
    const scrollPercentage = newLeft / maxMove;
    const scrollPosition = scrollPercentage * (baseRow.scrollWidth - baseRow.clientWidth);
    baseRow.scrollLeft = scrollPosition;
  };

  const stopDragging = () => {
    isDragging = false;
    document.body.style.cursor = 'default';
  };

  // Touch events
  indicatorBase.addEventListener('touchstart', startDragging);
  document.addEventListener('touchmove', handleDrag, { passive: false });
  document.addEventListener('touchend', stopDragging);

  // Mouse events
  indicatorBase.addEventListener('mousedown', startDragging);
  document.addEventListener('mousemove', handleDrag);
  document.addEventListener('mouseup', stopDragging);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["athlos-product-horizontal-slider-convertible-pants"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const baseRow = document.querySelector('.base-row');
  const indicator = document.querySelector('.indicator');
  const indicatorBase = document.querySelector('.indicator-base');
  // arrow click functionality
  const leftArrow = document.querySelector('.left-arrow');
  const rightArrow = document.querySelector('.right-arrow');
  const scrollWidth = baseRow.scrollWidth;
  const clientWidth = baseRow.clientWidth;

  // Add floating class to right arrow on page load
  rightArrow.classList.add('floating');


  // Scroll to the left when clicking the left arrow
  leftArrow.addEventListener('click', () => {
      // Calculate current scroll percentage
      const scrollPercentage = Math.ceil((baseRow.scrollLeft / (baseRow.scrollWidth - baseRow.clientWidth)) * 100);
      
      // Determine target percentage (0% or 50%)
      let targetPercentage;
      if (scrollPercentage > 100) {
          targetPercentage = 100;
      } else {
          targetPercentage = 0;
      }
      
      // Calculate target scroll position
      const targetPosition = (targetPercentage / 100) * (baseRow.scrollWidth - baseRow.clientWidth);
    console.log(targetPercentage, scrollPercentage, targetPosition)
      
      // Scroll to target position
      baseRow.scrollTo({
          left: targetPosition,
          behavior: 'smooth'
      });
  });
  
  // Scroll to the right when clicking the right arrow
  rightArrow.addEventListener('click', () => {
      // Stop the animation when clicked
      rightArrow.classList.remove('floating');
    
      // Calculate current scroll percentage
      const scrollPercentage = Math.ceil((baseRow.scrollLeft / (baseRow.scrollWidth - baseRow.clientWidth)) * 100);
      
      // Determine target percentage (50% or 100%)
      let targetPercentage;
      if (scrollPercentage < 100) {
          targetPercentage = 100;
      } else {
          targetPercentage = 100;
      }
      
      // Calculate target scroll position
      const targetPosition = (targetPercentage / 100) * (baseRow.scrollWidth - baseRow.clientWidth);
      // Scroll to target position
      baseRow.scrollTo({
          left: targetPosition,
          behavior: 'smooth'
      });
  });


  const maxMove = 59;
  let isDragging = false;
  let startX;
  let startLeft;

  //set initial display none
  leftArrow.style.display = 'none';


  // Update indicator position when scrolling
  baseRow.addEventListener('scroll', () => {
      const scrollPercentage = (baseRow.scrollLeft / (baseRow.scrollWidth - baseRow.clientWidth)) * 100;
      const indicatorPosition = (scrollPercentage / 100) * maxMove;
      indicator.style.left = `${indicatorPosition}px`;

    if(scrollPercentage === 0) {
      leftArrow.style.display = 'none';
    }
    else if (scrollPercentage === 100) {
      rightArrow.style.display = 'none';
    }
    else {
      leftArrow.style.display = 'block';
      rightArrow.style.display = 'block';
    }
  });

  // Update indicator position when scrolling
  baseRow.addEventListener('scroll', () => {
    const scrollPercentage = (baseRow.scrollLeft / (baseRow.scrollWidth - baseRow.clientWidth)) * 100;
    const indicatorPosition = (scrollPercentage / 100) * maxMove;
    indicator.style.left = `${indicatorPosition}px`;
  });

  // Handle touch events for mobile and mouse events for desktop
  const startDragging = (e) => {
    isDragging = true;
    startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
    startLeft = parseInt(indicator.style.left || 0);
    if (e.type === 'mousedown') document.body.style.cursor = 'grabbing';
  };

  const handleDrag = (e) => {
    if (!isDragging) return;
    e.preventDefault(); // Prevent scrolling while dragging

    const currentX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
    const deltaX = currentX - startX;
    let newLeft = startLeft + deltaX;

    // Constrain indicator movement
    newLeft = Math.max(0, Math.min(newLeft, maxMove));
    indicator.style.left = `${newLeft}px`;

    // Update scroll position
    const scrollPercentage = newLeft / maxMove;
    const scrollPosition = scrollPercentage * (baseRow.scrollWidth - baseRow.clientWidth);
    baseRow.scrollLeft = scrollPosition;
  };

  const stopDragging = () => {
    isDragging = false;
    document.body.style.cursor = 'default';
  };

  // Touch events
  indicatorBase.addEventListener('touchstart', startDragging);
  document.addEventListener('touchmove', handleDrag, { passive: false });
  document.addEventListener('touchend', stopDragging);

  // Mouse events
  indicatorBase.addEventListener('mousedown', startDragging);
  document.addEventListener('mousemove', handleDrag);
  document.addEventListener('mouseup', stopDragging);
  document.addEventListener('mouseup', () => {
    isDragging = false;
    document.body.style.cursor = 'default';
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-horizontal-scroll-women-all-day-crew"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const baseRow = document.querySelector('.base-row');
    const indicator = document.querySelector('.indicator-base .indicator');
    const indicatorBase = document.querySelector('.indicator-base');

    // arrow click functionality
    const leftArrow = document.querySelector('.left-arrow');
    const rightArrow = document.querySelector('.right-arrow');
    const scrollWidth = baseRow.scrollWidth;
    const clientWidth = baseRow.clientWidth;

    // Add floating class to right arrow on page load
    rightArrow.classList.add('floating');


    // Scroll to the left when clicking the left arrow
    leftArrow.addEventListener('click', () => {
        // Calculate current scroll percentage
        const scrollPercentage = Math.ceil((baseRow.scrollLeft / (baseRow.scrollWidth - baseRow.clientWidth)) * 100);
        
        // Determine target percentage (0% or 50%)
        let targetPercentage;
        if (scrollPercentage > 100) {
            targetPercentage = 100;
        } else {
            targetPercentage = 0;
        }
        
        // Calculate target scroll position
        const targetPosition = (targetPercentage / 100) * (baseRow.scrollWidth - baseRow.clientWidth);
      console.log(targetPercentage, scrollPercentage, targetPosition)
        
        // Scroll to target position
        baseRow.scrollTo({
            left: targetPosition,
            behavior: 'smooth'
        });
    });
    
    // Scroll to the right when clicking the right arrow
    rightArrow.addEventListener('click', () => {
        // Stop the animation when clicked
        rightArrow.classList.remove('floating');
      
        // Calculate current scroll percentage
        const scrollPercentage = Math.ceil((baseRow.scrollLeft / (baseRow.scrollWidth - baseRow.clientWidth)) * 100);
        
        // Determine target percentage (50% or 100%)
        let targetPercentage;
        if (scrollPercentage < 100) {
            targetPercentage = 100;
        } else {
            targetPercentage = 100;
        }
        
        // Calculate target scroll position
        const targetPosition = (targetPercentage / 100) * (baseRow.scrollWidth - baseRow.clientWidth);
        // Scroll to target position
        baseRow.scrollTo({
            left: targetPosition,
            behavior: 'smooth'
        });
    });

    const maxMove = 59;
    let isDragging = false;
    let startX;
    let startLeft;

    //set initial display none
    leftArrow.style.display = 'none';


    // Update indicator position when scrolling
    baseRow.addEventListener('scroll', () => {
        const scrollPercentage = (baseRow.scrollLeft / (baseRow.scrollWidth - baseRow.clientWidth)) * 100;
        const indicatorPosition = (scrollPercentage / 100) * maxMove;
        indicator.style.left = `${indicatorPosition}px`;

      if(scrollPercentage === 0) {
        leftArrow.style.display = 'none';
      }
      else if (scrollPercentage === 100) {
        rightArrow.style.display = 'none';
      }
      else {
        leftArrow.style.display = 'block';
        rightArrow.style.display = 'block';
      }
    });

    // Handle touch events for mobile and mouse events for desktop
    const startDragging = (e) => {
      isDragging = true;
      startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
      startLeft = parseInt(indicator.style.left || 0);
      if (e.type === 'mousedown') document.body.style.cursor = 'grabbing';
    };

    const handleDrag = (e) => {
      if (!isDragging) return;
      e.preventDefault(); // Prevent scrolling while dragging

      const currentX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
      const deltaX = currentX - startX;
      let newLeft = startLeft + deltaX;

      // Constrain indicator movement
      newLeft = Math.max(0, Math.min(newLeft, maxMove));
      indicator.style.left = `${newLeft}px`;

      // Update scroll position
      const scrollPercentage = newLeft / maxMove;
      const scrollPosition = scrollPercentage * (baseRow.scrollWidth - baseRow.clientWidth);
      baseRow.scrollLeft = scrollPosition;
    };

    const stopDragging = () => {
      isDragging = false;
      document.body.style.cursor = 'default';
    };

    // Touch events
    indicatorBase.addEventListener('touchstart', startDragging);
    document.addEventListener('touchmove', handleDrag, { passive: false });
    document.addEventListener('touchend', stopDragging);

    // Mouse events
    indicatorBase.addEventListener('mousedown', startDragging);
    document.addEventListener('mousemove', handleDrag);
    document.addEventListener('mouseup', stopDragging);
  });

  } catch(e) { console.error(e); }
})();
})();
